module.exports = parcelRequire.resolve("3JQe2");